import { AbstractControl, ValidationErrors } from '@angular/forms';

export function wellheadElevationAboveDfe(control: AbstractControl): ValidationErrors | null {
   const parent = control.parent;
   if (!parent) {
      return null;
   }

   const wellheadElevation = parent.get('wellheadElevation')?.value;
   const drillFloorElevation = parent.get('drillFloorElevation')?.value;

   if (wellheadElevation > drillFloorElevation) {
      return { error: 'Must be below or at DFE' };
   }

   return null;
}
